var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTimerOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 18.146-1.646-1.667q-.937.75-2.052 1.136Q11.188 18 10 18q-1.458 0-2.729-.552-1.271-.552-2.219-1.5t-1.5-2.219Q3 12.458 3 11q0-1.188.385-2.302.386-1.115 1.136-2.052L1.875 4l1.063-1.062 14.124 14.145ZM7.5 3V1.5h5V3Zm8.75 11.146-5.479-5.5L10.75 7h-1.5v.125L6.875 4.75q.729-.396 1.521-.573Q9.188 4 10 4q1.208 0 2.333.406 1.125.406 2.063 1.156l1.083-1.083 1.042 1.063-1.063 1.083q.75.937 1.146 2.063Q17 9.812 17 11q0 .812-.188 1.615-.187.802-.562 1.531Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimerOff);
export default __webpack_public_path__ + "static/media/icon-timer_off.a833591f356278f25659616ad3c91b84.svg";
export { ForwardRef as ReactComponent };